<div [ngClass]="chartContainerClass"></div>
